import { render } from "./equality-main.vue?vue&type=template&id=54bfb563&scoped=true"
import script from "./equality-main.vue?vue&type=script&lang=js"
export * from "./equality-main.vue?vue&type=script&lang=js"

import "./equality-main.vue?vue&type=style&index=0&id=54bfb563&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bfb563"],['__file',"src/components/applications/equality/equality-main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54bfb563"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54bfb563', __exports__)) {
    api.reload('54bfb563', __exports__)
  }
  
  module.hot.accept("./equality-main.vue?vue&type=template&id=54bfb563&scoped=true", () => {
    api.rerender('54bfb563', render)
  })

}


export default __exports__